import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gg-video-library-icon',
  templateUrl: './video-library-icon.component.html',
  styleUrl: './video-library-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoLibraryIconComponent {}
